export const LOGIN_COOKIE_NAME = "technician_access_token";
export const OFFERED_LEADS_TOPUP_COOKIE_NAME = "offered_leads_topup"
export const emitterEvents = {
	DONE_TOP_UP: 'doneTopUp'
}

export const APPOINTMENT_IMAGES_BUCKET = '/appointments'
